import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';
import { ExpansionPanelComponent } from 'src/app/shared/ui-kit/expansion-panel/expansion-panel.component';

import { TaskDetailsService } from '../../../task-details.service';

@Component({
  selector: 'app-policy-acceptation-message-content',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="mh-auto text-start text-left"
      *ngIf="
        (proposal?.proposalState === 'OFFER_ACCEPTED' ||
          proposal?.proposalState === 'SIGNED_DOCS' ||
          proposal?.proposalState === 'POLICY_CREATED') &&
        proposal?.memberDetails?.firstName &&
        proposal?.memberDetails?.lastName &&
        proposal?.policyDetails?.totalAmount &&
        proposal?.policyDetails?.offerId
      "
    >
      <span class="text-start text-left"
        >Par la présente, {{ proposal?.memberDetails?.firstName }}
        {{ proposal?.memberDetails?.lastName }} atteste avoir reçu la
        proposition <b>n°{{ proposal?.policyDetails?.offerId }}</b> ainsi que
        l'information aux clients et les conditions générales
        correspondantes.<br />{{ proposal?.memberDetails?.firstName }}
        {{ proposal?.memberDetails?.lastName }} confirme également l'exactitude
        des indications de la proposition et le fait que
        {{ proposal?.memberDetails?.firstName }}
        {{ proposal?.memberDetails?.lastName }} souhaite conclure le contrat
        d'assurance aux conditions mentionnées dans la proposition avec la prime
        annuelle indiquée de
        <b>{{ formatPrice(proposal?.policyDetails?.totalAmount!) }}</b
        >.<br />{{ proposal?.memberDetails?.firstName }}
        {{ proposal?.memberDetails?.lastName }} donne par ailleurs son
        autorisation conformément à la clause de consentement et aux
        informations sur la protection des données.</span
      >
    </div>
  `,
})
export class PolicyAcceptationMessageContent {
  @Input()
  proposal: ProposalDetails | null = null;

  formatPrice(price: number) {
    if (price == null || price === undefined) return 'CHF \\';
    const hasCents = price % 1 !== 0;
    let formattedNumber = price.toFixed(hasCents ? 2 : 0);
    formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return `CHF ${formattedNumber}`;
  }
}

@Component({
  selector: 'app-policy-acceptation-message',
  standalone: true,
  imports: [
    CommonModule,
    PolicyAcceptationMessageContent,
    ExpansionPanelComponent,
    CardComponent,
  ],
  templateUrl: './policy-acceptation-message.component.html',
})
export class PolicyAcceptationMessageComponent {
  get proposal(): ProposalDetails | null {
    return this.taskDetailsService?.state?.policy;
  }

  // The acceptation message only gets displayed if the customer has had to accept an offer (i.e there was a lead that was created beforehand)
  get hasLead(): boolean {
    return !!this.taskDetailsService?.state?.lead;
  }

  constructor(private readonly taskDetailsService: TaskDetailsService) {}
}
